import Layout from '@constants/layout';
var Routings = [
    {
        scope: 'ciceksepetiContactPermissions',
        paths: ['/hesabim/iletisim-izinlerim']
    },
    {
        scope: 'ciceksepetiContactPermissions',
        paths: ['/abonelikten-cik/:customerIdentifier'],
        layout: Layout.FULLWIDTH
    },
    {
        scope: 'ciceksepetiChangePassword',
        paths: ['/hesabim/sifremi-degistir']
    },
    {
        scope: 'ciceksepetiUserInfo',
        paths: ['/hesabim/bilgilerimi-duzenle']
    },
    {
        scope: 'ciceksepetiSavedCreditCards',
        paths: ['/hesabim/kartlarim', '/hesabim/kart-duzenle/:creditCardId']
    },
    {
        scope: 'ciceksepetiAddressBook',
        paths: ['/hesabim/adreslerim', '/hesabim/adres-duzenle/:addressId']
    },
    {
        scope: 'ciceksepetiReviews',
        paths: ['/hesabim/degerlendirmelerim', '/hesabim/degerlendirilmis-siparisler']
    },
    {
        scope: 'ciceksepetiReviews',
        paths: ['/siparis-degerlendir', '/sikayet-gorsel-gonder'],
        layout: Layout.FULLWIDTH
    },
    {
        scope: 'ciceksepetiReminders',
        paths: [
            '/hesabim/hatirlatmalarim',
            '/hesabim/hatirlatma-ekle',
            '/hesabim/hatirlatma-duzenle/:reminderId'
        ]
    },
    {
        scope: 'ciceksepetiOrders',
        paths: [
            '/hesabim/siparislerim',
            '/hesabim/yarim-kalan-siparislerim',
            '/hesabim/siparislerim/:orderId',
            '/siparis-takip-anonim',
            '/siparis-guncelle/:orderId',
            '/siparis-guncelle-anonim',
            '/siparis-iptal',
            '/siparis-iade'
        ]
    },
    {
        scope: 'ciceksepetiOrders',
        paths: ['/siparis-takip', '/siparis-satis-sozlesmesi'],
        layout: Layout.FULLWIDTH
    },
    {
        scope: 'ciceksepetiResponsiveMarketing',
        paths: ['/duyarli-pazarlama'],
        layout: Layout.FULLWIDTH
    },
    {
        scope: 'ciceksepetiMessages',
        paths: [
            '/hesabim/mesajlarim',
            '/hesabim/urun-mesajlarim',
            '/hesabim/satici-taleplerim',
            '/hesabim/destek-taleplerim'
        ]
    },
    {
        scope: 'ciceksepetiMessages',
        paths: [
            '/saticiya-sor',
            '/satici-taleplerim/:id',
            '/satici-taleplerim-anonim',
            '/destek-taleplerim/:id',
            '/destek-taleplerim-anonim'
        ],
        layout: Layout.FULLWIDTH
    },
    {
        scope: 'ciceksepetiCoupons',
        paths: ['/hesabim/kuponlarim']
    },
    {
        scope: 'ciceksepetiWallet',
        paths: ['/hesabim/cuzdanim']
    },
    {
        scope: 'ciceksepetiFavorites',
        paths: ['/hesabim/favorilerim']
    },
    {
        scope: 'ciceksepetiAuthenticationForms',
        paths: [
            '/customer/passwordrecoveryconfirm',
            '/sifremi-unuttum',
            '/uye-girisi',
            '/yeni-uyelik',
            '/oauth'
        ],
        layout: Layout.FULLWIDTH
    },
    {
        scope: 'ciceksepetiAuthenticationForms',
        paths: ['/kullanici-girisi'],
        layout: Layout.FULLWIDTH_LITE_HEADER_NO_FOOTER
    },
    {
        scope: 'ciceksepetiSurveys',
        paths: ['/musteri-memnuniyeti-anketi', '/teslimat-sureci', '/degerlendirme-anketi'],
        layout: Layout.FULLWIDTH
    },
    {
        scope: 'ciceksepetiPostOrderFeatures',
        paths: ['/mesaj-karti-goruntule', '/urun-gorsel-onay'],
        layout: Layout.FULLWIDTH
    },
    {
        scope: 'ciceksepetiPostCheckout',
        paths: ['/tesekkurler'],
        layout: Layout.FULLWIDTH
    },
    {
        scope: 'ciceksepetiCheckout',
        paths: ['/sepetim'],
        layout: Layout.FULLWIDTH
    },
    {
        scope: 'ciceksepetiCustomizableProducts',
        paths: ['/urun-kisisellestir', '/kisisellestirme-duzenle'],
        layout: Layout.FULLWIDTH_LITE_HEADER_NO_FOOTER
    }
];
export default Routings;
